export class NumberUtils {
   static divmod(dividend: number, divisor: number): [Quotient: number, Remainder: number] {
      const quotient = Math.floor(dividend / divisor);
      const remainder = dividend - divisor * quotient;
      return [quotient, remainder];
   }
}
